import { configs } from '../../../constants/configs/configs';
import { formatDateString } from '../../../utils/dates/dateMethods';

export const isCoverageValid = (startDate: string, endDate: string, currentDate: Date) => {
    let coverageStartDateFormatted: Date;
    let coverageEndDateFormatted: Date | null = null;

    if (!startDate) {
        return null; // Handle case where startDate is undefined or null
    }

    coverageStartDateFormatted = new Date(startDate);

    if (endDate) {
        coverageEndDateFormatted = new Date(endDate);
        return coverageEndDateFormatted < currentDate ? null : coverageStartDateFormatted <= currentDate;
    }

    return coverageStartDateFormatted <= currentDate;
};

export const formatDate = date => (date ? formatDateString(date) : 'N/A');

export const goToDashboard = () => {
    window.location.href = `${configs.routes.INDPORTAL}?goDash=true`;
};

export const isWithinRange = (value: number, min: number, max: number) => value >= min && value <= max;
